<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">
        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">
                    {{ $t("whMonitoringDocumentPhoto") }}
                  </h4>

                  <button
                    v-if="this.permision_role.method_create"
                    class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="createData()"
                  >
                    <i class="link-icon" data-feather="plus"></i>
                    {{ $t("createNew") }}
                  </button>
                  <button
                    v-if="this.permision_role.method_read"
                    class="btn btn-success float-end btn-xs"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                    <i class="link-icon" data-feather="download"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>
                </div>

                <div class="card-body">
                  <vue-good-table
                    mode="remote"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                    }"
                    :rows="rows"
                    :columns="columns"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <a
                          href="#"
                          v-if="permision_role.method_read"
                          title="Detail"
                          @click.prevent="detailData(props.index, props.row)"
                        >
                          <i class="mdi mdi-eye" style="font-size: 16px"></i>
                        </a>
                        <a
                          href="#"
                          v-if="permision_role.method_update"
                          title="Edit"
                          @click.prevent="editData(props.index, props.row)"
                        >
                          <i
                            class="mdi mdi-square-edit-outline"
                            style="font-size: 16px"
                          ></i>
                        </a>

                        <a
                          href="#"
                          title="Download Zip"
                          @click.prevent="downloadZip(props.index, props.row)"
                        >
                          <i
                            class="mdi mdi-folder-download"
                            style="font-size: 16px"
                          ></i>
                        </a>
                        <a
                          href="#"
                          title="Add Zip Queue"
                          @click.prevent="addZipJob(props.index, props.row)"
                        >
                          <i
                            class="mdi mdi-zip-box"
                            style="font-size: 16px"
                          ></i>
                        </a>
                        <a
                          href="#"
                          v-if="
                            permision_role.method_delete == true &&
                            props.row.status !== 'delete'
                          "
                          title="Click for Deactive"
                          @click.prevent="deleteData(props.index, props.row)"
                        >
                          <i class="mdi mdi-close" style="font-size: 16px"></i>
                        </a>
                      </span>
                      <span v-else-if="props.column.field == 'zip_job_status'">
                        <a :href="props.row.zip_url" target="_blank" v-if="props.row.zip_job_status === 'COMPLETED'">{{ props.row.zip_job_status }}</a>
                        <p v-else>{{ props.row.zip_job_status }}</p>
                      </span>
                      <span v-else-if="props.column.field == 'warehouse_name'">
                        {{ props.row.warehouse.name }}
                      </span>
                      <span v-else-if="props.column.field == 'customer_name'">
                        {{ props.row.customer.name }}
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import { getAuthToken } from "@/middleware/auth";

export default {
  name: "DocumentPhotoIndex",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      maxToasts: 100,
      company_types: [],
      position: "up right",
      closeBtn: true,
      isLoading: false,
      permision_role: [],
      errors: [],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      rows: [],
    };
  },
  watch: {},
  computed: {
    columns() {
      return [
        {
          label: this.$t("fulfillment_code"),
          field: "warehouse_id",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("fulfillment_code"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("fulfillment_name"),
          field: "warehouse_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("fulfillment_name"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("customerId_txt"),
          field: "customer_id",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("customerId_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("customerName_txt"),
          field: "customer_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("customerName_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("driver_name"),
          field: "driver_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("driver_name"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("vehicle_no"),
          field: "vehicle_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("vehicle_no"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Type",
          field: "type",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Type", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["PO", "SO"], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Reference No",
          field: "reference_no",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Reference No", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Zip Job Status",
          field: "zip_job_status",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Zip Job Status", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [
              "Requested",
              "Complete",
              "Processing",
              "Pending",
              "Failed",
            ], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("status"),
          field: "status",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("status"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("create_at_txt"),
          field: "created_at",
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss", // format of the raw data
          dateOutputFormat: "yyyy-MM-dd HH:mm:ss",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By " + this.$t("create_at_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
          },
        },
        {
          label: this.$t("addwho"),
          field: "created_by",
          filterOptions: {
            enabled: false, // enable filter for this column
            placeholder: "Filter By " + this.$t("addwho"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: window.innerWidth < 768 ? "" : "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("action_txt"),
          field: "actions",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    addZipJob(index, row) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("addZipJobQueue"),
        showCancelButton: true,
        showDenyButton: true,
        denyButtonText: "Yes & Compress",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#5cd672",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        this.isLoading = true;

        let url = null;
        let body = {};
        if (result.value) {
          url =
            this.$settings.endpointWhMonitoring +
            "v1/document-header/request-zip/" +
            row.document_header_id;
          console.log("Confirm");
        } else if (result.isDenied) {
          url =
            this.$settings.endpointWhMonitoring +
            "v1/document-header/request-zip/" +
            row.document_header_id;
          body = {
            is_compress: "Y",
          };
        } else {
          this.isLoading = false;
        }

        if (url) {
          this.$http
            .post(url, body)
            .then((response) => {
              if (response.data.status == 200) {
                console.log(response);
                this.$swal({
                  icon:"success",
                  title:"Success",
                  text:"Pending Queue Job : "+response.data.datas.pending_job
                });
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }

              this.loadItems();
            })
            .catch((error) => {
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            }).finally(()=>this.loading());
        }
      });
    },
    downloadZip: async function (index, row) {
      const baseURI =
        this.$settings.endpointWhMonitoring +
        "v1/document-header/download-zip/" +
        row.document_header_id;
      this.isLoading = true;
      try {
        // Use fetch to make the request
        const response = await fetch(baseURI, {
          headers: {
            // "Content-Type": "application/zip",
            Authorization: "Bearer " + getAuthToken(),
          },
          method: "POST",
        });

        const contentType = response.headers.get('content-type');

        if (contentType && contentType.includes("application/json")) {
          const json = await response.json();
          // console.log(json);
          this.resultError(json.errors);
          // this.error(json.message || "Unknown error");
          this.loading();
          return;
        }

        // IMPORTANT: Fetch does NOT reject on HTTP error statuses (like 404, 500).
        // You must manually check response.ok.
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response.status} - ${response.statusText}`,
          );

        }
        
        // Get the filename from the 'Content-Disposition' header if available
        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = "download.zip"; // Default filename
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
          }
        }

        // Get the response body as a Blob (binary large object)
        const blob = await response.blob();

        // --- DEBUGGING: Log the blob size vs Content-Length from header ---
        // console.log("Blob size (bytes):", blob.size);
        // console.log("Content-Length header:", response.headers.get('Content-Length'));
        // --- END DEBUGGING ---

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element to trigger download
        const a = document.createElement("a");
        a.href = url;
        a.download = filename; // Set the download attribute
        document.body.appendChild(a); // Append to body
        a.click(); // Programmatically click
        a.remove(); // Remove after click

        // Revoke the Blob URL to free up resources
        window.URL.revokeObjectURL(url);
        this.loading();
      } catch (err) {
        this.error(err)
        this.loading();
      }
    },
    uploadData() {
      window.location.href = "/wh-monitoring/warehouse/upload";
    },

    downloadData() {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/document-header/index";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouse_id=${this.serverParams.columnFilters.warehouse_id}&warehouse_name=${this.serverParams.columnFilters.warehouse_name}&customer_id=${this.serverParams.columnFilters.customer_id}&customer_name=${this.serverParams.columnFilters.customer_name}&status=${this.serverParams.columnFilters.status}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&driver_name=${this.serverParams.columnFilters.driver_name}&type=${this.serverParams.columnFilters.type}&created_at=${this.serverParams.columnFilters.created_at}&ref_no=${this.serverParams.columnFilters.reference_no}&download=download`,
          {
            responseType: "blob",
          },
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    createData() {
      window.location.href = "/wh-monitoring/document-photo/create";
    },

    editData(index, row) {
      var params = this.$onRandom(row.document_header_id);
      window.location.href = "/wh-monitoring/document-photo/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.document_header_id);
      window.location.href = "/wh-monitoring/document-photo/detail/" + params;
    },

    deleteData(index, row, status) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: status,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          const baseURI =
            this.$settings.endpointWhMonitoring +
            "v1/document-header/delete/" +
            row.document_header_id;
          this.$http
            .delete(baseURI, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));
              } else {
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                  } else if (error.response.status === 401) {
                    this.logout();
                  } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    // load items is what brings back the rows from server
    loadItems() {
      const baseURI =
        this.$settings.endpointWhMonitoring + "v1/document-header/index";
      // var columnFilters = this.serverParams.columnFilters;

      // var company_code = columnFilters["company_detail.code"];

      this.isLoading = true;
      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&warehouse_id=${this.serverParams.columnFilters.warehouse_id}&warehouse_name=${this.serverParams.columnFilters.warehouse_name}&customer_id=${this.serverParams.columnFilters.customer_id}&customer_name=${this.serverParams.columnFilters.customer_name}&status=${this.serverParams.columnFilters.status}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&driver_name=${this.serverParams.columnFilters.driver_name}&type=${this.serverParams.columnFilters.type}&created_at=${this.serverParams.columnFilters.created_at}&ref_no=${this.serverParams.columnFilters.reference_no}&zip_job_status=${this.serverParams.columnFilters.zip_job_status}`,
          { timeout: 10000 },
        )
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;

          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (
          permision.permission !== null &&
          permision.permission.controller ==
            "WhMonitoringDocumentHeaderController"
        ) {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

      var status = this.$route.query.status;
      if (status == "200") {
        this.success(this.$route.query.msg);
      }
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });

      this.$logoutUser();
      window.location.href = "/";
    },

    getSystemCode() {
      const baseURI =
        this.$settings.endPoint + "system-code/select?system_code=COMPANY_TYPE";

      return this.$http
        .get(baseURI, { timeout: 10000 })
        .then((response) => {
          var rows = response.data.datas.data;
          if (rows.length > 0) {
            rows.forEach((reValue) => {
              var data = { value: reValue.value, text: reValue.description };
              this.company_types.push(data);
            });
            // return rows;
          }
        })
        .catch((error) => {
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.logout();
              } else if (error.response.status === 403) {
                this.$router.push("/authorized-error");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          }
        });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped></style>
